import { App } from 'vue'
import Datepicker from './LpDatepicker.vue'

Datepicker.install = (Vue: App) => {
  Vue.component(Datepicker.name, Datepicker)
}

export default Datepicker
